<template>
  <div style="height:100%">
    <el-row type="flex" justify="end" class="title-bar">
      <div class="vertical-center-box">
        <el-button size="small" class="mr-r4" @click="clickDeleteTableDataButton">지우기</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="table" border header-align="center" :data="tableData" :columns="tableColumns"
    :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="false" :fit-height="true" @row-click="clickRow"
    style="height: calc(100% - 52px);border-bottom: 1px solid #EBEEF5;">
    </el-table-wrapper>
  </div>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WMibBrowserTable',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSearchTool: false,
      tableColumns: [
        {
          prop: 'oid',
          label: 'OID',
          width: 180,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'value',
          label: '결과 값',
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'valueTypeString',
          label: '타입',
          width: 110,
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    clickDeleteTableDataButton() {
      this.$emit('set-table-data', []);
    },
    clickRow(row) {
      this.$emit('set-oid', row.oid);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/MibBrowser/components/MibBrowserTable.vue